// extracted by mini-css-extract-plugin
export default {"text":"HText_text__b001Q"};